import { useEffect } from 'react'

import { useOktaAuth } from './okta-browser'

export function SignOut() {
  const auth = useOktaAuth()

  useEffect(() => {
    auth.oktaAuth.signOut()
  }, [auth.oktaAuth])

  return null
}
